import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { F } from '@/utils/intl';
import PrettyDate from '@/components/PrettyDate';
import { MessageMediumRenderer, MessageRendererProps } from '@/components/Communication/types';
import { MessageOutlined } from '@ant-design/icons';
import styles from './SMS.less';

const { Text } = Typography;

const SMSSummary: React.FC<MessageRendererProps> = ({ message }) => (
  <div className={styles.smsSummaryContainer}>
    <MessageOutlined className={styles.smsIcon} />
    <Text ellipsis className={styles.smsSummaryContent}>
      {message.content}
    </Text>
  </div>
);

const SMSExtensive: React.FC<MessageRendererProps> = ({ message }) => (
  <div className={styles.smsExtensiveContainer}>
    <div className={styles.smsExtensiveHeader}>
      <Text strong>
        <MessageOutlined className={styles.smsIcon} /> <F id="communication.medium.sms" defaultMessage="SMS" />
      </Text>
      <Text type="secondary" className={styles.smsExtensiveTimestamp}>
        <PrettyDate date={message.timestamp} />
      </Text>
    </div>
    <Text ellipsis className={styles.smsExtensiveContent}>{message.content}</Text>
  </div>
);

const SMSPreview: React.FC<MessageRendererProps> = ({ message }) => (
  <div className={styles.smsPreviewContainer}>
    <Space direction="vertical" className={styles.smsPreviewSpace} size="small">
      <Tag color="blue">
        <MessageOutlined /> <F id="communication.medium.sms" defaultMessage="SMS" />
      </Tag>
      <Text strong className={styles.smsPreviewSender}>
        <F id="communication.attribute.from" defaultMessage="From:" /> {message.sender}
      </Text>
      <div className={styles.smsBubble}>
        <Text className={styles.smsBubbleText}>{message.content}</Text>
      </div>
      <Text type="secondary" className={styles.smsPreviewTimestamp}>
        <PrettyDate date={message.timestamp} />
      </Text>
    </Space>
  </div>
);

const SMSRenderers: MessageMediumRenderer = {
  Summary: SMSSummary,
  Extensive: SMSExtensive,
  Preview: SMSPreview,
};

export default SMSRenderers;
